// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#not-found[data-v-5747eb6d]{max-width:70rem;margin:auto}#not-found img[data-v-5747eb6d]{width:100%}#not-found #text-container header[data-v-5747eb6d]{font-size:2.2rem}#not-found #text-container .main-body[data-v-5747eb6d]{font-size:1.5rem;margin-top:1rem}@media(max-width:600px){#not-found #text-container header[data-v-5747eb6d]{font-size:1.5rem}#not-found #text-container .main-body[data-v-5747eb6d]{font-size:1rem}}", ""]);
// Exports
module.exports = exports;
